import React from "react";
import { Admin, Resource } from "react-admin";
import frenchMessages from "ra-language-french";
import UserIcon from "@material-ui/icons/Group";
import KioskCreate from "./components/kioskCreate";
import KioskEdit from "./components/kioskEdit";
import KioskShow from "./components/kioskShow";
import KioskList from "./components/kioskList";
import {
  StationList,
  StationEdit,
  StationCreate,
  StationShow,
} from "./components/stations";
import { UserList, UserEdit, UserCreate, UserShow } from "./components/users";
import Dashboard from "./components/dashboard";
import Login from "./components/login";
import authProvider from "./authProvider";
import provider from "./dataProviderFeathers";
import { REMOTEHOST } from "./config";
import createRealtimeSaga from "./sagas/createRealtimeSaga";

const dataProvider = provider(REMOTEHOST);
const realTimeSaga = createRealtimeSaga(dataProvider);

const messages = {
  fr: {
    ...frenchMessages,
    button: {
      connect: "Démarrer",
      disconnect: "Pause",
    },
    notification: {
      startOfSell: "Démarrage de la vente",
      endOfSell: "Interruption de la vente",
      errorSending: "Erreur lors de l'envoi du message",
    },
  },
};

const i18nProvider = (locale) => messages[locale];

const App = () => (
  <Admin
    title="AlpiLink Admin"
    authProvider={authProvider}
    dashboard={Dashboard}
    dataProvider={dataProvider}
    customSagas={[realTimeSaga]}
    locale="fr"
    i18nProvider={i18nProvider}
    loginPage={Login}
  >
    {(permissions) => [
      <Resource
        name="kiosks"
        list={KioskList}
        edit={permissions === "super_admin" ? KioskEdit : null}
        create={permissions === "super_admin" ? KioskCreate : null}
        show={KioskShow}
        options={{ label: "Bornes" }}
      />,
      permissions === "super_admin" || permissions === "station_admin" ? (
        <Resource
          name="users"
          list={UserList}
          edit={UserEdit}
          create={UserCreate}
          show={UserShow}
          icon={UserIcon}
          options={{ label: "Utilisateurs" }}
        />
      ) : null,
      permissions === "super_admin" ? (
        <Resource
          name="stations"
          list={StationList}
          edit={StationEdit}
          create={StationCreate}
          show={StationShow}
        />
      ) : null,
    ]}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js